import { CREATE_NOTIFICATION, REMOVE_NOTIFICATION } from '../constants/notifications';

/**
 * @param {CreateNotificationPayload} notification
 * @returns {{payload: CreateNotificationPayload, type: string}}
 */
export const createNotification = (notification) => ({
  type: CREATE_NOTIFICATION,
  payload: {
    id: +new Date() + Math.random(),
    ...notification
  }
});

export const removeNotification = ({ id }) => ({
  type: REMOVE_NOTIFICATION,
  payload: { id }
});
